export default async function usePim<T = any>(filename: string): Promise<T> {
  const config = useRuntimeConfig()

  let httpBaseUrl: string = config.public.pimDataBaseUrl

  if (!httpBaseUrl) {
    throw new Error('PIM_HTTP_BASE_URL environment variable is not configured.')
  }

  if (!httpBaseUrl.startsWith('http://') && !httpBaseUrl.startsWith('https://')) {
    throw new Error('Invalid PIM_HTTP_BASE_URL format. Must start with http:// or https://')
  }

  // Safely construct URL
  const cleanFilename = filename.startsWith('/') ? filename.slice(1) : filename
  const cleanBaseUrl = httpBaseUrl.endsWith('/') ? httpBaseUrl.slice(0, -1) : httpBaseUrl
  const url = new URL(cleanFilename, `${cleanBaseUrl}/`)

  if (process.server) {
    url.searchParams.set('cacheKey', 'ssr')
  }

  const httpUrl = url.toString()

  const {ofetch} = await import('ofetch')

  let responseText: string

  // only used for local development and for the client process to avoid CORS issues
  if (config.public.environment === 'DEV' && process.client) {
    responseText = await ofetch<string>(`/api/pim/${cleanFilename}`, {
      responseType: 'text',
      retry: 3,
      retryDelay: 250,
      retryStatusCodes: [404, 500, 503]
    } as any)
  } else {
    responseText = await ofetch<string>(httpUrl, {
      responseType: 'text',
      retry: 3,
      retryDelay: 250,
      retryStatusCodes: [404, 500, 503]
    } as any)
  }

  const parsed = JSON.parse(responseText) as T
  return parsed
}
